import { render, staticRenderFns } from "./AddressMetadataView.vue?vue&type=template&id=08cb6132&scoped=true&"
import script from "./AddressMetadataView.vue?vue&type=script&lang=js&"
export * from "./AddressMetadataView.vue?vue&type=script&lang=js&"
import style0 from "./AddressMetadataView.vue?vue&type=style&index=0&id=08cb6132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb6132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDataTable,VDivider,VLayout,VSpacer,VTextField})
